export enum GuestAccountType {
    Default = 1,
    Social = 2,
}
